import React from "react";
import { Route, Switch } from "react-router-dom";
import AuditLogList from "./AuditLogList";
var AuditLog = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: ["".concat(match.path, "/:id"), match.path], render: function (routeProps) { return (React.createElement(AuditLogList, { selectedId: routeProps.match.params.id })); } })));
};
export default AuditLog;
